import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService, RestService } from '../../../../services/common';
import { SalesService } from '../../sales.service';
import { ICommonDropdownResponse } from '../../../../common-components/common-table/common-table.model';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';
import { ErrorMessages } from '../../../../../errormessages';
import { ToasterService } from '../../../../services/common/toaster.service';
declare const $: any;

@Component({
  selector: 'app-allotment-list',
  templateUrl: './allotment-list.component.html',
  styleUrl: './allotment-list.component.scss'
})
export class AllotmentListComponent implements OnInit {
  @Output() changeAddUpdateAllotmentState = new EventEmitter<any>();

  showExport: boolean = false;
  exportSelectedType: string = '';
  fileName = '';
  context: any;
  gridOptions: any;
  overlayNoRowsTemplate: string = '<span>No records found</span>';
  frameworkComponents: any;
  excelStyles: any[] = [];
  filterTerm!: string;
  defaultColDef: any;
  dummyDataUrl: string = '../../../../../assets/dummydb/';
  columnDefs: any[];
  //data!: any[];
  @Input() allotmentListData: any;
  selectedExportData: any[] = [];


  isDropdownOpen = false;
  columnKeys: any[] = [
    'customerName',
    'product',
    'sourceName',
    'amount',
    'contactNumber',
  ];
  ActionList: boolean = false;
  isVisible = false;
  dropdownMenu: any;
  editIcon = environment.assetsImagePath + IconList.EditIconDropdown
  transferIcon = environment.assetsImagePath + IconList.TransferIcon
  paymentIcon = environment.assetsImagePath + IconList.PaymentIcon
  cancelIcon = environment.assetsImagePath + IconList.AllotmentCancelIcon

  //column which are exporting
  exportColumns: any[] = [
    // {
    //   cellClass: 'cellCenter',
    //   headerCheckboxSelection: true,
    //   checkboxSelection: true,
    //   maxWidth: 65,
    // },
    // { headerName: 'Client Name', field: 'customerName', type: 'leftAligned' },
    // {
    //   headerName: 'Agent Name',
    //   field: 'sourceName',
    //   cellStyle: { textAlign: 'center' },
    // },
    // {
    //   headerName: 'Unit Category',
    //   field: 'product',
    //   cellStyle: { textAlign: 'center' },
    // },
    // {
    //   headerName: 'Amount',
    //   field: 'amount',
    //   cellStyle: { textAlign: 'center' },
    //   hide: true,
    //   supressToolPanel: true,
    // },
    // {
    //   headerName: 'Contact Number',
    //   field: 'contactNumber',
    //   cellStyle: { textAlign: 'center' },
    //   hide: true,
    //   supressToolPanel: true,
    // },
  ];
  dialogData = { title: '', message: '' };
  showDialog = false;
  cancelledRowData: any;

  constructor(public commonService: CommonService, private salesService: SalesService, private toastr: ToasterService, public router: Router) {
    this.context = this;
    this.columnDefs = [];
  }

  ngOnInit(): void {

    this.columnDefs = [
      // @ts-ignore
      {

        field: 'selection', columnType: 'checkbox'
      },
      {
        header: 'Client Name', field: 'clientName', columnType: 'text'
      },
      {
        header: 'Agent Name', field: 'sourceName', columnType: 'text'
      },
      {
        header: 'Unit Category',
        field: 'product',
        columnType: 'text',
      },
      {
        header: 'Unit No.',
        field: 'unitNo',
        columnType: 'text',
      },
      {
        header: 'Amount',
        field: 'amount',
        columnType: 'text'
      },
      {
        header: 'Received Amount',
        field: 'recivedAmount',
        columnType: 'text'
      },
      {
        header: 'Received %',
        field: 'percentageAmount',
        columnType: 'text'
      },
      {
        header: 'Contact No',
        field: 'contactNumber',
        columnType: 'phone'
      },
      {
        header: 'Actions', field: 'action', columnType: 'dropdown', options: [
          { label: 'Edit', value: 'edit', icon: this.editIcon },
          { label: 'Transfer', value: 'transfer', icon: this.transferIcon },
          { label: 'Payment', value: 'payment', icon: this.paymentIcon },
          { label: 'Cancel', value: 'cancel', icon: this.cancelIcon }
        ]
      }
    ];

  }

  onCommonTableDropdownChange(commonDropdownValue: ICommonDropdownResponse) {
    const selectedRoute = commonDropdownValue?.route;
    // this.salesService.currentBooking = commonDropdownValue?.currentRow;
    if (selectedRoute == 'payment') {
      // this.NavigateToPaymentRoute(commonDropdownValue?.currentRow)
    } else if (selectedRoute == 'allotment') {
      //this.NavigateToAllotmentRoute(commonDropdownValue?.currentRow)
    } else if (selectedRoute == 'document') {
      // this.changeDocumentModelStatus.emit({
      //  "currentSelectedRecord": commonDropdownValue.currentRow
      // })
    } if (selectedRoute == 'edit') {
      this.changeAddUpdateModalState(commonDropdownValue.currentRow)
    }
    if (selectedRoute == 'cancel') {
      this.cancelledRowData = commonDropdownValue.currentRow;
      this.showConfirmation();
    }
  }

  onCommonTableDropdownMobileChange(data: any, type: any) {
    // this.salesService.currentBooking = data;
    if (type == 'payment') {
    } else if (type == 'transfer') {
    } else if (type == 'cancel') {
    } else if (type == 'edit') {
      this.changeAddUpdateModalState(data)
    }
  }

  dropdownActonMenu(paymentId: any) {
    this.dropdownMenu = document.getElementById("actionMenuContent" + paymentId);
    this.dropdownMenu?.classList.toggle("dropdownActionMenu");
    this.ActionList = !this.ActionList;
  }

  toggleEditAction(rowData: any) {

  }

  showConfirmation() {
    this.showDialog = true;
    this.dialogData = { title: 'Confirm', message: 'Are you sure you want to cancel this allotment?' };
  }

  onConfirmed(result: any) {
    if (result) {
      // User confirmed, perform cancel allotment.
      this.salesService.cancelledAllotment(this.cancelledRowData.id).subscribe((result: any) => {
        this.toastr.showSuccess(ErrorMessages.cancelledAllotment);
        this.changeAddUpdateAllotmentState.emit({
          "showaddUpdateModal": false,
          "isCancelled": true
        });
      });
    }
    this.showDialog = false; // Hide dialog after action
  }

  changeAddUpdateModalState(currentRecord?: any) {
    // this.salesService.currentBooking = currentRecord
    this.changeAddUpdateAllotmentState.emit({
      "showaddUpdateModal": true,
      isNewCustomer: currentRecord == undefined ? true : false,
      currentSelectedRecord: currentRecord
    });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleExport(type: string) {
    this.exportSelectedType = type;
    this.showExport = !this.showExport;
  }

  /**
* set data to form after exporting the selected data
* @param {any} data
*/
  exportValues(data: any) {
    // if (data) {
    //   this.form.controls['customerName'].setValue(data[0]?.clientName);
    //   this.form.controls['amount'].setValue(data[0]?.amount);
    //   this.showExport = false;
    // }
  }

  exportDataToFile(fileFormat: string) {

  }

  // to hide export modal
  hideExport() {
    this.showExport = false;
    $('.modal').modal('hide');
  }


  onSelectedRowsChange(selectedRows: any) {
    this.selectedExportData = [];
    let exportedObject: any[] = [];

    if (selectedRows?.length > 0)
      selectedRows.forEach((row: any) => {
        let allotmentObject = row
        if (allotmentObject) {
          let rowData = {
            "Client Name": ((allotmentObject?.clientDetail?.nameInitial?.name) ? (allotmentObject?.clientDetail?.nameInitial?.name + '.') : '') + ' ' +
              ((allotmentObject?.clientDetail?.firstName) ? (allotmentObject?.clientDetail?.firstName) : '') + ' ' +
              ((allotmentObject?.clientDetail?.lastName) ? (allotmentObject?.clientDetail?.lastName) : ''),
            "Agent Name": row?.sourceName,
            "Unit Category": row?.unitCategory,
            "Unit No.": row?.unitDescription,
            "Amount": row?.amount,
            "Received Amount": row?.recivedAmount,
            "Received %": row?.percentageAmount
          };
          exportedObject.push(rowData);
        }
      });

    this.selectedExportData = exportedObject;
  }
}
